import React, { useState, useEffect } from "react";
import { Form, Button, Alert, Spinner, Card } from "react-bootstrap";
import {
  IconShieldCheck,
  IconRobot,
  IconArrowRight,
} from "@tabler/icons-react";
import TurnstileWidget from "../../../components/TurnstileWidget";
import usePublicAgent from "../../../hooks/usePublicAgent";

const PhoneValidation = ({
  onValidationSuccess,
  agentName,
  isLoading,
  error,
  turnstileResetTrigger = 0,
}) => {
  const { getTurnstileConfiguration } = usePublicAgent();
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileError, setTurnstileError] = useState("");
  const [resetTurnstile, setResetTurnstile] = useState(0);

  // Effect para reagir ao turnstileResetTrigger externo
  useEffect(() => {
    if (turnstileResetTrigger > 0) {
      setResetTurnstile(turnstileResetTrigger);
      setTurnstileToken("");
      setTurnstileError("");
    }
  }, [turnstileResetTrigger]);

  useEffect(() => {
    const loadTurnstileConfig = async () => {
      try {
        const result = await getTurnstileConfiguration();
        if (!result.success) {
          console.warn(
            "Erro ao carregar configuração Turnstile:",
            result.error
          );
        }
      } catch (error) {
        console.warn("Erro ao carregar configuração Turnstile:", error);
      }
    };

    loadTurnstileConfig();
  }, [getTurnstileConfiguration]);

  const handleTurnstileToken = (token) => {
    setTurnstileToken(token);
    if (turnstileError) {
      setTurnstileError("");
    }
  };

  const handleTurnstileError = (error) => {
    setTurnstileError(error);
    setTurnstileToken("");
  };

  const handleTurnstileExpired = () => {
    setTurnstileToken("");
    setTurnstileError(
      "Token de segurança expirado. Complete a verificação novamente."
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!turnstileToken) {
      setTurnstileError("Complete a verificação de segurança");
      setResetTurnstile((prev) => prev + 1);
      return;
    }

    onValidationSuccess(turnstileToken);
  };

  const canSubmit = turnstileToken && !isLoading;

  return (
    <div className="public-validation-container">
      <div className="public-validation-content">
        <Card className="border-0 shadow-lg">
          <Card.Body className="p-5">
            {/* Header */}
            <div className="text-center mb-4">
              <div
                className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "64px",
                  height: "64px",
                  background: "var(--gradient-primary)",
                  color: "white",
                }}
              >
                <IconRobot size={32} />
              </div>

              <h3 className="fw-bold text-primary mb-2">
                Teste o Agente {agentName}
              </h3>

              <p className="text-muted mb-0">
                Complete a verificação de segurança para começar a conversar
              </p>
            </div>

            {/* Formulário */}
            <Form onSubmit={handleSubmit}>
              {/* Turnstile */}
              <div className="mb-4">
                <div className="turnstile-wrapper">
                  <TurnstileWidget
                    onTokenChange={handleTurnstileToken}
                    onError={handleTurnstileError}
                    onExpired={handleTurnstileExpired}
                    resetTrigger={resetTurnstile}
                    size="normal"
                    theme="light"
                  />
                </div>

                {turnstileError && (
                  <Alert variant="danger" className="mt-3 mb-0">
                    <small>{turnstileError}</small>
                  </Alert>
                )}
              </div>

              {/* Erro Geral */}
              {error && (
                <Alert variant="danger" className="mb-4">
                  {error}
                </Alert>
              )}

              {/* Botão Submit */}
              <Button
                type="submit"
                disabled={!canSubmit}
                className="w-100 d-flex align-items-center justify-content-center gap-2"
                style={{
                  height: "48px",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  background: canSubmit ? "var(--gradient-primary)" : "#6c757d",
                  border: "none",
                  boxShadow: canSubmit
                    ? "0 4px 12px rgba(59, 130, 246, 0.3)"
                    : "none",
                }}
              >
                {isLoading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Validando...
                  </>
                ) : (
                  <>
                    Iniciar Conversa
                    <IconArrowRight size={18} />
                  </>
                )}
              </Button>
            </Form>

            {/* Footer */}
            <div className="text-center mt-4">
              <small className="text-muted">
                <IconShieldCheck size={14} className="me-1" />
                Protegido por verificação anti-bot
              </small>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default PhoneValidation;
